import React, { Suspense, useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { useGLTF, OrbitControls } from '@react-three/drei'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import * as THREE from 'three'

export function ArmModel() {
  const { nodes, materials, scene } = useGLTF('/Models/UR5E.glb')
  const groupRef = useRef()

  // Log for debugging
  console.log(nodes)
  console.log(materials)
  console.log(scene)


  return (
    <group ref={groupRef}>
      <primitive object={scene} />
    </group>
  )
}

export default function Arm() {
  return (
    <>
      <div className='comp__header'>
        <p>3D Arm View</p>
        <MoreVertIcon className='icon more__icon'/>
      </div>
      <div className='printer__canvas'>
        <Canvas
          camera={{ position: [1.5, 1.5, 1], fov: 50 }}
        >
          <ambientLight intensity={0.5} />
          <pointLight position={[10, 10, 10]} intensity={1} />
          <Suspense fallback={null}>
            <ArmModel />
          </Suspense>
          <OrbitControls />
        </Canvas>
      </div>
    </>
  );
}